import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import AreaLevelSetting from "../AreaLevelSetting";
import AreaSelectedSetting from "../AreaSelectedSetting";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMonitorPage, setMonitorPage, setMonitorShowSelected } from "../../../reducer/monitorPageSlice";


function MonitorSetting() {
    const dispatch = useDispatch();
    // const [page, setPage] = useState("timeline");
    const page = useSelector(getMonitorPage);
    const [monitorSelected, setMonitorSelected] = useState({
        eocactive: process.env.REACT_APP_ENABLE_FULL_FUNCTION === "true" ? true : false,
        eocqualify: true,
        eocunactive: process.env.REACT_APP_ENABLE_FULL_FUNCTION === "true" ? true : false
    })
    const { eocactive, eocqualify, eocunactive } = monitorSelected;

    const monitorSelectedChange = (event) => {
        setMonitorSelected({
            ...monitorSelected,
            [event.target.name]: event.target.checked,
        });
    };

    useEffect(() => {
        dispatch(setMonitorShowSelected(monitorSelected));
        // console.log(monitorSelected);
    }, [monitorSelected, dispatch])

    return (
        <>
            <div className='px-4'>
            <Box className="pt-2 pb-4">
                    <Typography variant="subtitle1" className='mb-2'>
                        รูปแบบการแสดงผล
                    </Typography>
                    <ToggleButtonGroup
                        fullWidth
                        size='small'
                        value={page}
                        exclusive
                        onChange={(event) => {
                            dispatch(setMonitorPage(event.target.value));
                        }}
                        aria-label="Platform"
                        >
                        <ToggleButton className='text-base text-blue-gray-900' value="map">แผนที่</ToggleButton>
                        <ToggleButton className='text-base text-blue-gray-900' value="table">ตาราง</ToggleButton>
                        <ToggleButton className='text-base text-blue-gray-900' value="timeline">ไทม์ไลน์</ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {page === "map" && (
                    <Box sx={{
                        textAlign: 'left'
                    }}>
                        <Typography variant="subtitle1" >
                            การแสดงผล
                        </Typography>
                        <FormControl sx={{ mt: '5px', width: '100%' }} component="fieldset" variant="standard">
                            <FormGroup>
                                {
                                    process.env.REACT_APP_ENABLE_FULL_FUNCTION === "true" ? <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={eocactive}
                                                    onChange={monitorSelectedChange}
                                                    name="eocactive"
                                                    sx={{
                                                        color: 'rgba(0, 0, 0, 0.6)',
                                                        '&.Mui-checked': {
                                                            color: 'rgb(212, 135, 108)',
                                                        },
                                                    }} />
                                            }
                                            label="เปิด EOC"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={eocunactive}
                                                    onChange={monitorSelectedChange}
                                                    name="eocunactive"
                                                    sx={{
                                                        color: 'rgba(0, 0, 0, 0.6)',
                                                        '&.Mui-checked': {
                                                            color: 'rgb(212, 135, 108)',
                                                        },
                                                    }} />
                                            }
                                            label="ไม่เปิด EOC"
                                        />
                                    </> : <></>
                                }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={eocqualify}
                                            onChange={monitorSelectedChange}
                                            name="eocqualify"
                                            sx={{
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                '&.Mui-checked': {
                                                    color: 'rgb(212, 135, 108)',
                                                },
                                            }} />
                                    }
                                    label="เข้าเกณฑ์เปิด EOC"
                                />
                            </FormGroup>
                        </FormControl>
                    </Box>
                )}
                <AreaSelectedSetting />
                <AreaLevelSetting />
            </div>

            {/* <RenderTypeSetting /> */}
            {/* <AreaSelectedSetting /> */}
        </>
    )
}

export default MonitorSetting;